import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DropDownView, TextView } from 'components';
import TagsInputViewV2 from 'components/TagsInputViewV2';
import useChannelDetails, { channelsMap } from 'hooks/useChannelDetails';
import {
  ICategories,
  addCategories,
  fetchConfig,
} from 'redux/content/content.slice';
import { RootState } from 'redux/store/store';

import LeftContainer from './LeftContainer';

export type ButtonType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'delete'
  | 'special';

const CategoriesTemplate = () => {
  const categoriesData = useSelector(
    (state: RootState) => state.content.content
  );

  const filterData = useSelector(
    (store: RootState) => store.content.config.data
  );

  const { channel } = useChannelDetails();

  const dispatch = useDispatch();

  const [categoriesTemplateData, setCategoriesTemplateData] =
    useState<ICategories>({
      type: categoriesData.type,
      product: categoriesData.product,
      bucket: categoriesData.bucket,
      tags: categoriesData.tags,
    });
  useEffect(() => {
    dispatch(
      addCategories({
        categories: categoriesTemplateData,
      })
    );
  }, [categoriesTemplateData]);
  useEffect(() => {
    dispatch(fetchConfig());
  }, []);
  function getDropDownData(data: string[]) {
    return data?.map((value) => ({ label: value, value }));
  }
  return (
    <div className="flex flex-row ">
      <LeftContainer>
        <div className="flex flex-col pt-4  gap-4 min-h-[619px] max-h-[619px]">
          <div className="flex flex-col gap-2">
            <div>
              <TextView
                textType="body"
                color="#475467"
                size={18}
                fontStyle="normal"
                weight="700"
                lineHeight={28}
                text={`Add categories for your ${
                  channelsMap[channel as keyof typeof channelsMap].name
                } template`}
              />
            </div>
            <div>
              <TextView
                textType="body"
                color="#475467"
                size={14}
                fontStyle="normal"
                weight="400"
                lineHeight={20}
                text={
                  'Fill in all the necessary categories that will help organize your templates easily'
                }
              />
            </div>
          </div>
          <div className="flex flex-row z-[300] gap-4 ">
            <DropDownView
              key={'1'}
              dropdownData={getDropDownData(filterData?.OutreachTypes)}
              handleClick={function (data: { label: string; value: string }) {
                setCategoriesTemplateData(
                  (prev): ICategories => ({
                    ...prev,
                    type: data.value,
                  })
                );
              }}
              value={categoriesTemplateData.type}
              title="Outreach type*"
              placeholder="Select outreach type"
            />
            <DropDownView
              key={'2'}
              dropdownData={getDropDownData(filterData?.AssetClass)}
              handleClick={function (data: { label: string; value: string }) {
                setCategoriesTemplateData(
                  (prev): ICategories => ({
                    ...prev,
                    product: data.value,
                  })
                );
              }}
              value={categoriesTemplateData.product}
              title="Asset class*"
              placeholder="Select asset class"
            />
          </div>
          <div className="flex flex-row z-[100] gap-4 w-[49%]">
            <DropDownView
              key={'3'}
              dropdownData={getDropDownData(filterData?.Bucket)}
              handleClick={(data: { label: string; value: string }) => {
                setCategoriesTemplateData(
                  (prev): ICategories => ({
                    ...prev,
                    bucket: data.value,
                  })
                );
              }}
              value={categoriesTemplateData.bucket}
              title="Bucket*"
              placeholder="Select bucket"
            />
          </div>
          <div>
            <TagsInputViewV2
              title="Tag"
              tags={categoriesTemplateData.tags}
              onTagsChange={(newTag) => {
                setCategoriesTemplateData(
                  (prev): ICategories => ({ ...prev, tags: newTag })
                );
              }}
            />
            <div>
              <TextView
                textType="body"
                color="#667085"
                size={12}
                fontStyle="normal"
                weight="100"
                lineHeight={18}
                text={'Add filter tags for your outreach'}
              />
            </div>
          </div>
        </div>
      </LeftContainer>
    </div>
  );
};

export default CategoriesTemplate;
